import React, { useEffect } from 'react';
import { useAuth0, useSettings, useSiteConfig, } from '@innovyze/stylovyze/lib/contexts';
import Fallback from './Fallback';
import { getService } from '@innovyze/stylovyze/lib/utils/getService';
import { useIsFeatureEnabled } from '@innovyze/stylovyze/lib/utils/features';
import { useSelectUserContext } from '@innovyze/stylovyze/lib/selectors/userContext.selectors';
import { STYLOVYZE_FLAGS } from '../../types';
// Adding in import of map lib globals provider if it exists in project
// otherwise fallback to rendering the children passed in
// Currently you can only do optional importing with require in a catch block
// and cannot yet be done with Rect.lazy and import();
let Provider;
try {
    //eslint-disable-next-line @typescript-eslint/no-var-requires
    Provider = require('@innovyze/inno-map').MapGlobalProvider;
    if (Provider === undefined) {
        console.error('Upgrade @innovyze/inno-map to get the MapGlobalProvider');
    }
}
catch (e) {
    Provider = Fallback;
}
const mapManagementUrl = getService('mapManagement');
const MapProviderInternal = ({ children }) => {
    const { config } = useSiteConfig();
    const { token } = useAuth0();
    const { companySettings, settingsLoaded } = useSettings();
    const distanceUnit = companySettings?.UOM?.toLowerCase?.();
    const defaultBoundary = companySettings?.defaultNetworkBoundarySWNELngLat ?? [];
    const defaultThemeId = companySettings?.mapSettings?.defaultTheme;
    const searchRadius = companySettings?.mapSettings?.searchRadius;
    const unitSystem = companySettings?.UOM ?? 'Metric';
    const colorByMaxValues = useIsFeatureEnabled('map-color-by-attribute-max-values');
    const showMultiThemes = useIsFeatureEnabled('map-show-multi-themes');
    const showArcGISBasemaps = useIsFeatureEnabled(STYLOVYZE_FLAGS.ARCGIS_BASEMAPS);
    const basemapOrigin = showArcGISBasemaps
        ? companySettings?.mapSettings?.basemapOrigin
        : 'mapbox';
    const { defaultSite } = useSelectUserContext();
    const localStoragePrefix = defaultSite;
    useEffect(() => {
        console.warn('MapProvider settings', companySettings?.mapSettings);
        if (settingsLoaded && defaultBoundary.length === 0) {
            console.warn('No defaultNetworkBoundarySWNELngLat value set for this tenant');
        }
    }, [settingsLoaded, defaultBoundary]);
    return (React.createElement(Provider, { value: {
            mapKey: config?.mapbox.key || '',
            arcGISBasemapStylesToken: showArcGISBasemaps
                ? config?.mapbox.arcGISKey || null
                : null,
            defaultBounds: defaultBoundary,
            basemapOrigin: basemapOrigin,
            distanceUnit,
            themeEndpoint: {
                url: mapManagementUrl,
                token,
            },
            colorByMaxValues,
            showMultiThemes,
            localStoragePrefix,
            unitSystem,
            defaultThemeId,
            searchRadius,
        } }, children));
};
export const MapProvider = ({ disable, children, }) => {
    if (disable) {
        return React.createElement(React.Fragment, null, children);
    }
    else {
        return React.createElement(MapProviderInternal, null, children);
    }
};
export default MapProvider;
